import { render, staticRenderFns } from "./SurveyTable.vue?vue&type=template&id=4e643f3b&scoped=true"
import script from "./SurveyTable.vue?vue&type=script&lang=js"
export * from "./SurveyTable.vue?vue&type=script&lang=js"
import style0 from "./SurveyTable.vue?vue&type=style&index=0&id=4e643f3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e643f3b",
  null
  
)

export default component.exports